import styled from 'styled-components';
import { theme } from '@frameio/vapor';

type Size = 'small' | 'large';

export const DotSeparator = styled.span<{ $color?: string; $size?: Size }>`
  color: ${({ $color = theme.colors.icon.interactive.off }) => $color};
  display: inline-block;
  font-size: ${({ $size }) =>
    $size === 'large' ? theme.fontSizes[300] : theme.fontSizes[60]};
  height: ${theme.spaces[16]};
  line-height: ${theme.lineHeights[50]};
  position: relative;
  vertical-align: middle;
  width: ${theme.spaces[12]};

  &:after {
    content: '·';
    /* Optically center dot vertically between text elements */
    left: 0;
    position: absolute;
    text-align: center;
    width: 100%;
  }
`;
